import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CustomCurrencyPipe } from '../../pipe/currency/mycurrencypipe.pipe';
import { TakeLanguageOfBrowserService } from '../../common/_services/takeLanguageOfBrowser.service';
import { SUPPORTED_LANGUAGES } from '../../config/locale.config';
import { LocaleService } from '../../common/_services/locale.service';
import { ImageFallbackDirective } from '../../directive/ellipsis/image-fallback.directive';
import { FormatChemicalElementPipe } from '../../pipe/format-chemical-element/format-chemical-element.pipe';
import { environment } from '../../../environments/environment';
import { ImageLazyLoadDirective } from '../../common/_directives/ImageLazyLoad.directive';
import { StrapiImageSharpDirective } from '../../common/_directives/strapiImageSharp.directive';
import { FadeDirective } from '../../common/_directives/fade.directive';

@NgModule({
  declarations: [CustomCurrencyPipe, ImageFallbackDirective, FormatChemicalElementPipe],
  imports: [
    CommonModule,
    NgxPermissionsModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    FadeDirective,
    ImageLazyLoadDirective,
    StrapiImageSharpDirective,
  ],
  exports: [
    CommonModule,
    NgxPermissionsModule,
    TranslateModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    CustomCurrencyPipe,
    ImageFallbackDirective,
    FormatChemicalElementPipe,
    FadeDirective,
    ImageLazyLoadDirective,
    StrapiImageSharpDirective,
  ],
  providers: [TranslateService, TakeLanguageOfBrowserService],
})
export class SharedModule {
  constructor(
    private readonly translate: TranslateService,
    private readonly takeLanguageOfBrowserService: TakeLanguageOfBrowserService,
    private readonly localeService: LocaleService
  ) {
    const languages = SUPPORTED_LANGUAGES;
    if (environment.enableTranslateMode) {
      const pseudoLanguage = 'ach';
      languages.push(pseudoLanguage);
    }
    this.translate.addLangs(languages);

    this.translate.setDefaultLang(this.takeLanguageOfBrowserService.getLanguage());

    const currentLang =
      localStorage.getItem('crntLng') || this.takeLanguageOfBrowserService.getLanguage();
    this.translate.use(currentLang);
    this.localeService.setLocale(currentLang);
  }
}
